const KEY = 'bmec_chat_v1';
const TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days per BUILD_PLAN decisions log

export type StoredMessage = {
  role: 'user' | 'assistant';
  content: string;
  timestamp: number;
};

export type StoredState = {
  conversationId?: string;
  messages: StoredMessage[];
};

type Stored = StoredState & { savedAt: number };

export function loadConversation(): StoredState {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { messages: [] };
    const data = JSON.parse(raw) as Stored;
    if (!data || !Array.isArray(data.messages)) return { messages: [] };
    if (Date.now() - data.savedAt > TTL_MS) {
      localStorage.removeItem(KEY);
      return { messages: [] };
    }
    return { conversationId: data.conversationId, messages: data.messages };
  } catch {
    return { messages: [] };
  }
}

export function saveConversation(state: StoredState): void {
  try {
    const data: Stored = { ...state, savedAt: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // localStorage may be disabled (private mode, quota). Fail silently.
  }
}

export function clearConversation(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
